// Marry-me-one-question — variant. Renders
// /templates/marry-me-one-question.html (one-question romantic "for you"
// template, deep wine + paper + rose-gold, Cormorant Garamond + Pinyon
// Script) inside a full-bleed iframe. Designer showcase template
// without a query-string customizer — params are passed through for
// forward compatibility.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/marry-me-one-question.html";

export function MarryMeOneQuestionStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();

  // names = "Sender & Recipient" (or "For Recipient · only") — pass both.
  if (t.names) {
    const [sender, recipient] = t.names.split(/\s*&\s*/);
    if (sender) params.set("names", sender.trim());
    if (recipient) params.set("recipient", recipient.trim());
    else params.set("recipient", t.names.trim());
  }
  if (t.date) {
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.time) params.set("time", t.time);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (ctx.slug) params.set("slug", ctx.slug);
  params.set("v", "2");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;
  return (
    <iframe
      src={src}
      title={t.names || "Marry Me"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#1A0911",
      }}
    />
  );
}
